import React from 'react';
import PropTypes from 'prop-types';
import VideoPlayer from '../../../components/VideoPlayer';
import styles from './styles.less';

const Player = ({ videoUrl, firstTitle, secondTitle }) => {
    const [playerSize, setPlayerSize] = React.useState(false);
    const [closePlayer, setClosePlayer] = React.useState(true);
    const [maxSize, setMaxSize] = React.useState(false);
    const [showBackDrop, setShowBackDrop] = React.useState(false);
    const [mobile, setMobile] = React.useState(false);
    const [play, setPlay] = React.useState(false);
    const [startFullScreenOneTime, setStartFullScreenOneTime] = React.useState(false);
    const [animate, setAnimate] = React.useState(false);

    React.useEffect(() => {
        const windowWidth = window.screen.width;
        if (windowWidth < 768) {
            setMobile(true);
        }
    }, []);

    function handleClosePlayer() {
        setClosePlayer(false);
    }

    function handleStart() {
        if (!startFullScreenOneTime) {
            setPlayerSize(true);
            setMaxSize(true);
            setShowBackDrop(true);
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100%';
            setStartFullScreenOneTime(true);
        }
        if (mobile) {
            setPlay(true);
        }
        setAnimate(true);
    }

    function makeMiddScreen() {
        if (!mobile) {
            setPlayerSize(true);
            setMaxSize(true);
            setShowBackDrop(true);
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100%';
        }
    }

    function closeFullScreen() {
        setPlayerSize(false);
        setMaxSize(false);
        setShowBackDrop(false);
        document.body.style.overflow = 'unset';
        if (mobile) {
            setPlay(false);
        }
    }
    function makeMiddScreenMobile() {
        setPlayerSize(true);
        setMaxSize(true);
        setShowBackDrop(true);
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
        setPlay(true);
    }

    function shouldAnimate() {
        if (!animate) {
            return 'animaiteVideoContainer';
        }
        return '';
    }
    return (
        <>
            {closePlayer && videoUrl && (
                <div
                    className={[
                        !maxSize ? styles.playerContainerMin : styles.playerContainerMax,
                        styles[shouldAnimate()],
                    ].join(' ')}
                >
                    <div className={styles.close}>
                        {!maxSize && (
                            <span onClick={() => handleClosePlayer()}>
                                <img
                                    src="/static/images/course/close.svg"
                                    alt="fullScreen"
                                    className={styles.fullScreen}
                                />
                            </span>
                        )}
                    </div>
                    <div className={styles.playerInnerContainer}>
                        <VideoPlayer
                            //            className={[styles[changeSize()]]}
                            width="100%"
                            height="100%"
                            url={videoUrl}
                            onPlay={() => {
                                handleStart();
                            }}
                            playing={play}
                            light={!mobile}
                            controls
                            onClick={() => setPlay(true)}
                        />
                    </div>
                    {!maxSize && mobile && (
                        <span
                            onClick={() => {
                                makeMiddScreenMobile();
                            }}
                            className={styles.thumbnail}
                        >
                            <img
                                src="/static/images/course/videoThumbnail.png"
                                alt="thumbnail"
                                className={styles.fullScreen}
                            />
                        </span>
                    )}
                    <div className={styles.footerContainer}>
                        <div className={styles.textContainer}>
                            <span>{firstTitle}</span>
                            <span>{secondTitle}</span>
                        </div>
                        {!maxSize ? (
                            <span
                                onClick={() => {
                                    handleStart();
                                    makeMiddScreen();
                                }}
                            >
                                <img
                                    src="/static/images/course/fullScreen.svg"
                                    alt="fullScreen"
                                    className={styles.fullScreen}
                                />
                            </span>
                        ) : (
                            <span onClick={() => closeFullScreen()}>
                                <img
                                    src="/static/images/course/smallScreen.svg"
                                    alt="smallScreen"
                                    className={styles.smallScreen}
                                />
                            </span>
                        )}
                    </div>
                </div>
            )}
            {showBackDrop && <div className={styles.backDrop} onClick={() => closeFullScreen()} />}
        </>
    );
};

Player.propTypes = {
    videoUrl: PropTypes.string.isRequired,
    firstTitle: PropTypes.string,
    secondTitle: PropTypes.string,
};

Player.defaultProps = {
    firstTitle: '',
    secondTitle: '',
};

export default Player;
